<template>
    <div class="formitem">
        <a-card>
            <template slot="title">
                <v-gobackbutton v-show="isGuide != 'process'">返回</v-gobackbutton>
                {{ c_title }}
            </template>
            <a-form @submit="handleSubmit" layout="inline" name="servicekeyitem" :form="form">
                 <a-row v-if="action == 'add'  && C.Env != 'pro'">
                    <a-form-item label="所属环境">
                        <a-checkbox-group v-decorator="[
                                'checkEnvs',
                                {
                                    initialValue: checkEnvs,
                                    rules: [{ required: true, message: '请输勾选环境' }]
                                }
                            ]">
                            <a-checkbox v-for="item in envList" :key="item" :value="item" name="click">
                                {{item}}
                            </a-checkbox>

                        </a-checkbox-group>
                    </a-form-item>
                </a-row>
                <a-row v-if="action == 'edit'">
                    <a-form-item label="所属环境">
                        <a-tag color="green">{{C.Env}}</a-tag>
                    </a-form-item>
                </a-row>
                <a-row>
                    <a-form-item label="所属领域">
                        <a-select
                            style="width:180px"
                            placeholder="请选择服务所属领域"
                            @change="handleDomainChange"
                            v-decorator="[
                                'domain',
                                {
                                    initialValue: record.domain ? record.domain : '001',
                                    rules: [{ required: true, message: '所属领域' }]
                                }
                            ]"
                        >
                            <a-select-option key="001">前台</a-select-option>
                            <a-select-option key="002">中台</a-select-option>
                            <a-select-option key="003">开放</a-select-option>
                            <a-select-option key="004">基础</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-row>
                <a-row>
                    <a-form-item label="应用编码">
                        <a-input
                            max-Length="180"
                            placeholder="应用编码"
                            style="width:600px"
                            autoComplete="new-password"
                            v-decorator="[
                                'appcode',
                                {
                                    initialValue: record.appcode,
                                    rules: [{ required: true, message: '请输入应用编码' }]
                                }
                            ]"
                            @click="handleSelecter"
                        />
                    </a-form-item>
                    <AppSelecter :modalState="modalState" @onModalHide="onAppselecterHide"></AppSelecter>
                </a-row>
                <a-row>
                    <a-form-item label="服务key" :extra="servicekeyTip">
                        <a-input
                            v-if="action == 'add' || action == 'copy'"
                            :addon-before="servicekeyBefore"
                            max-Length="100"
                            placeholder="请输入服务key"
                            style="width:600px"
                            v-decorator="[
                                'servicekey',
                                {
                                    initialValue: record.servicekey,
                                    rules: [{ required: true, message: '请输入服务key' }]
                                }
                            ]"
                        />
                        <span v-else>{{record.servicekey}}</span>
                    </a-form-item>
                </a-row>
                <a-row>
                    <a-form-item label="服务描述">
                        <a-input
                            max-Length="200"
                            placeholder="请输入服务描述"
                            style="width:600px"
                            v-decorator="[
                                'servicedesc',
                                {
                                    initialValue: record.servicedesc,
                                    rules: [{ required: false, message: '请输入服务描述' }]
                                }
                            ]"
                        />
                    </a-form-item>
                </a-row>
                <a-row>
                    <a-form-item label="服务配置">
                        <a-input
                            max-Length="600"
                            style="width:600px"
                            v-decorator="[
                                'serviceconfig',
                                {
                                    initialValue: record.serviceconfig || '',
                                    rules: [{ required: true, message: '请输入服务配置。' }]
                                }
                            ]"
                        />

                    </a-form-item>
                </a-row>
                <a-row>
                    <!-- <a-form-item label="目标分支">
                        <a-input
                            max-Length="600"
                            style="width:600px"
                            v-decorator="[
                                'targetbranch',
                                {
                                    initialValue: record.targetbranch || '',
                                    rules: [{ required: true, message: '请输入目标分支。' }]
                                }
                            ]"
                        /> -->
                        <a-form-item label="目标分支">
                            <a-input
                                max-Length="600"
                                style="width:600px"
                                v-decorator="[
                                'targetbranch',
                                {
                                    initialValue: record.targetbranch || '',
                                    rules: [{ required: true, message: '请输入目标分支。' }]
                                }
                            ]"
                            />
                    </a-form-item>
                </a-row>

                <a-row>
                    <a-form-item label="接口类型">
                        <a-select
                            style="width:180px"
                            placeholder="请选择接口类型"
                            v-decorator="[
                                'interfacetype',
                                {
                                    initialValue: record.interfacetype ? record.interfacetype : [],
                                    rules: [{ required: true, message: '请选择接口类型' }]
                                }
                            ]"
                        >
                            <a-select-option key="http">http</a-select-option>
                            <a-select-option key="rpc">rpc</a-select-option>
                            <a-select-option key="dispatch">dispatch</a-select-option>
                            <a-select-option key="local">local</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-row>

                <a-row>
                    <a-form-item label="免鉴权">
                        <a-radio-group
                            v-decorator="[
                                'entry',
                                {
                                    initialValue: record.entry || '1',
                                }
                            ]"
                        >
                            <a-radio value="1">是</a-radio>
                            <a-radio value="0">否</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-row>
                <a-row>
                    <a-form-item label="接口验签">
                        <a-radio-group
                            v-decorator="[
                                'encryptflag',
                                {
                                    initialValue: record.encryptflag || '0',
                                }
                            ]"
                        >
                            <a-radio value="1">是</a-radio>
                            <a-radio value="0">否</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-row>
                <a-row>
                    <a-form-item label="上下线状态">
                        <a-radio-group
                            v-decorator="[
                                'serviceflag',
                                {
                                    initialValue: record.serviceflag || '1',
                                }
                            ]"
                        >
                            <a-radio value="1">上线</a-radio>
                            <a-radio value="0">下线</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-row>
                <a-row>
                    <a-form-item label="收费接口">
                        <a-radio-group
                            v-decorator="[
                                'ischarge',
                                {
                                    initialValue: record.ischarge || '0',
                                }
                            ]"
                        >
                            <a-radio value="1">是</a-radio>
                            <a-radio value="0">否</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-row>
                <a-row v-if="is_frount">
                    <a-form-item label="路由其它领域">
                        <a-radio-group
                            v-decorator="[
                                'routeflag',
                                {
                                    initialValue: record.routeflag || '0',
                                }
                            ]"
                            @change="handleRoutFlagChange"
                        >
                            <a-radio value="1">是</a-radio>
                            <a-radio value="0">否</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-row>

                <a-row v-if="is_frount && is_routS">
                    <a-form-item label="关联其它领域服务">
                        <a-input
                            max-Length="100"
                            style="width:600px"
                            v-decorator="[
                                'routeservicekey',
                                {
                                    initialValue: record.routeservicekey || '',
                                }
                            ]"
                            @click="handleServicekeyModal"
                        />
                        <a-input
                            v-decorator="[
                                'routedomain',
                                {
                                    initialValue: record.routedomain || '',
                                }
                            ]"
                            type="hidden"
                        />

                        <ServiceKeySelecter :modalState="modalStateServicekey"
                                            @onModalHide="onServiceKeyselecterHide"></ServiceKeySelecter>
                    </a-form-item>
                </a-row>
                <!--                <a-row>
                                    <a-form-item label="服务授权验证码">
                                        <a-input
                                            style="width:300px"
                                            max-Length="32"
                                            v-decorator="[
                                                'authcode',
                                                {
                                                    initialValue: record.authcode || '',
                                                    //rules: [{ required: true, message: '请输入服务授权验证码' }]
                                                }
                                            ]"
                                        />
                                    </a-form-item>
                                    <a-form-item>
                                        <a @click="this.randomAuthCode">随机生成授权验证码</a>
                                    </a-form-item>
                                </a-row>-->
                    <a-row  v-if="is_frount">
                        <a-form-item label="参数是否转换">
                             <a-radio-group
                                 v-decorator="[
                                     'parameter',
                                     {
                                         initialValue: record.parameter || '0',
                                     }
                                 ]"
                                 @change="handleParameterFlagChange"
                             >
                                <a-radio value="1">是</a-radio>
                                <a-radio value="0">否</a-radio>
                            </a-radio-group>
                        </a-form-item>
                    </a-row>
                     <a-row v-if="is_frount && is_Parameter">
                        <a-form-item label="参数转换配置">
                            <a-textarea
                                style="width:600px"
                                max-Length="1000"
                                v-decorator="[
                                    'parameterways',
                                    {
                                        initialValue: record.parameterways,
                                        rules: [{ required: false, message: '请输入参数转换配置' }]
                                    }
                                ]"
                            />
                        </a-form-item>
                    </a-row>
                    <a-row v-if="is_frount && is_Parameter">
                        <a-form-item label="参数转换条件">
                            <a-textarea
                                style="width:600px"
                                max-Length="1000"
                                v-decorator="[
                                    'parameterconditions',
                                    {
                                        initialValue: record.parameterconditions,
                                        rules: [{ required: false, message: '请输入参数转换条件' }]
                                    }
                                ]"
                            />
                        </a-form-item>
                    </a-row>
                <a-row>
                    <a-form-item label="请求报文样例">
                        <a-textarea
                            style="width:600px"
                            max-Length="1000"
                            v-decorator="[
                                'requesttemplate',
                                {
                                    initialValue: record.requesttemplate,
                                    rules: [{ required: false, message: '请输入请求样例报文' }]
                                }
                            ]"
                        />
                    </a-form-item>
                </a-row>
                <a-row>
                    <a-form-item label="返回报文样例">
                        <a-textarea
                            style="width:600px"
                            max-Length="1000"
                            v-decorator="[
                                'responsetemplate',
                                {
                                    initialValue: record.responsetemplate,
                                    rules: [{ required: false, message: '请输入返回样例报文' }]
                                }
                            ]"
                        />
                    </a-form-item>

                </a-row>
                <a-row>
                    <a-form-item label="负责人">
                        <a-input
                            max-Length="600"
                            style="width:600px"
                            autoComplete="new-password"
                            class=""
                            v-decorator="[
                                'serviceadmin',
                                {
                                    initialValue: record.serviceadmin || '',
                                    rules: [{ required: false, message: '' }]
                                }
                            ]"
                        />
                    </a-form-item>
                </a-row>
                <a-row>
                    <a-form-item label="负责人电话">
                        <a-input
                            max-Length="600"
                            style="width:600px"
                            autoComplete="new-password"
                            v-decorator="[
                                'telephone',
                                {
                                    initialValue: record.telephone || '',
                                    rules: [{ required: false, message: '' }]
                                }
                            ]"
                        />
                    </a-form-item>
                </a-row>
                <a-row>
                    <a-form-item label="接口地址">
                        <a-input
                            max-Length="600"
                            autoComplete="new-password"
                            style="width:600px"
                            v-decorator="[
                                'apiurl',
                                {
                                    initialValue: record.apiurl || '',
                                    rules: [{ required: false, message: '' }]
                                }
                            ]"
                        />
                    </a-form-item>
                </a-row>
                <a-row>
                    <!-- v-if="action == 'add'" record.isauthed == 1 ||  -->
                    <a-form-item label=" " :colon="false">
                        <!--                    <a-form-item label=" " :colon="false">-->
                        <!--                    <a-form-item label=" " :colon="false" v-if="record.isauthed == 1 || action == 'add'">-->
                        <a-button
                            :disabled="disabled"
                            :key="this.loading.key"
                            :loading="this.loading.effects[addType] || this.loading.effects[editType] || tloading"
                            type="primary"
                            htmlType="submit"
                        >保存
                        </a-button>
                        <a-button style="margin-left: 10px;" @click="handleCancel">
                            取消
                        </a-button>
                    </a-form-item>
                </a-row>
            </a-form>
        </a-card>
    </div>
</template>

<script>
// import { mapGetters } from "vuex";
import ServiceKeySelecter from '@/components/ServiceKeySelecter';
import {mapState} from "vuex";
import AppSelecter from '@/components/AppSelecter'


const storeNamespace = "servicekey";
const serviceKeyNums = {
    '001': 'zl.bs.',
    '002': 'zl.cs.',
    '003': 'zl.open.',
    '004': 'zl.fp.',
}

const stip1 = ' 前台 zl.bs.{业务}.{模块}.{方法}  （保障业务切换是命名统一）';
const stip2 = '中台 zl.cs.{系统}.{模块}.{方法}     (区分服务提供方）';

export default {
    components: {
        AppSelecter,
        ServiceKeySelecter,
    },
    data() {
        return {
            formLayout: "horizontal",
            form: this.$form.createForm(this),
            storeNamespace,
            addType: `${storeNamespace}/add`,
            editType: `${storeNamespace}/edit`,
            detailType: `${storeNamespace}/detail`,
            servicekeyBefore: '',
            randomMD5: null, //随机授权验证码
            c_title: '请填写表单内容',
            action: this.$route.params.action,
            disabled: this.$route.params.action == "detail" ? true : false, //查看详情的时候禁用编辑框 跟 按钮
            modalState: {//选择app弹框
                isShow: false,
                rowsType: 'radio' // or 'checkbox'，单选或多选
            },
            modalStateServicekey: {
                isShow: false,
                rowsType: 'radio',
                domain: '',
                selectkeys: [],
            },
            is_new_servicekey: true,
            is_frount: true,
            is_routS: false,
            is_Parameter: false,
            servicekeyTip: '',
            data: [],
            envList:[
                'pre',
                'uat',
                'pet',
                'fat',
                'sit',
                'sim',
                'dev',
            ],
            checkEnvs:[
                'pre',
                'uat',
                'pet',
                'fat',
                'sit',
                'sim',
                'dev',
            ],
            tloading:false
        };
    },
    computed: {
        ...mapState(storeNamespace, {
            record: function (state) {
                //这里需要注意 this 指向问题, 如果用箭头函数, 会有this作用域的问题

                return this.action == "add" ? {
                    appcode: '', responsetemplate: '',
                    requesttemplate: '',
                    authcode: '',
                    servicedesc: ''
                } : state.record;
            }
        })
    },
    props: {
        isGuide: String
    },
    methods: {
        handleCancel() {
            this.$router.back(-1);
        },
        handleRoutFlagChange(e) {
            this.is_routS = e.target.value == '1'
            this.record.routeservicekey = ''
            this.record.routeflag = e.target.value
        },
        handleParameterFlagChange(e) {
            this.is_Parameter = e.target.value == '1'
            this.record.parameter = e.target.value
        },
        handleDomainChange(v, current_key) {
            // this.is_frount = v == '001' || v == 'new';
            // record.servicekey
            if (typeof (current_key) == 'object') {
                current_key = this.record.servicekey
            }
            current_key = current_key ? current_key : '';
            if (current_key != '' && !this.servicekeyBefore) {
                this.is_new_servicekey = current_key.indexOf('zl.bs') == 0 || current_key.indexOf('zl.cs') == 0 || current_key.indexOf('zl.open') == 0 || current_key.indexOf('zl.fp') == 0
            } else {
                this.is_new_servicekey = true;
            }
            //判断当前servicekey是否是老的
            if (!this.is_new_servicekey && v != 'new') {
                console.log('老')
                this.servicekeyBefore = ''
            } else {
                v = v == 'new' ? '001' : v;
                this.servicekeyBefore = serviceKeyNums[v];
                this.record.servicekey = this.record.servicekey ? this.record.servicekey : ''
                this.record.servicekey = this.record.servicekey.replace(this.servicekeyBefore, '')
            }
            this.is_routS = this.record.routeflag == '1';
            this.is_Parameter = this.record.parameter == '1';
            if (this.is_frount) {
                this.servicekeyTip = stip1;
            } else if (v == '002') {
                this.servicekeyTip = stip2
            } else {
                this.servicekeyTip = ''
            }
        },
        handleBranchChange(value){
            console.log(value)
            this.record.targetbranch = value
        },
        onAppselecterHide(result) {
            console.log(result)
            if (result == undefined) {
                this.modalState.isShow = false;
                return;
            }
            if (result.length > 0) {
                this.record.appcode = result[0].appcode
                this.form.setFieldsValue({
                    appcode: result[0].appcode,
                });
            }
            this.modalState.isShow = false;
        },
        handleSelecter() {
            this.modalState.isShow = true;
        },
        handleServicekeyModal() {
            this.modalStateServicekey.filterServicekey = [(this.servicekeyBefore + this.record.servicekey)];
            this.modalStateServicekey.isShow = true;

        },
        onServiceKeyselecterHide(result) {
            if (result == undefined) {
                this.modalStateServicekey.isShow = false;
                return
            }
            let current_service_key = result[0].servicekey;
            this.form.setFieldsValue({
                routeservicekey: current_service_key,
            });
            this.form.setFieldsValue({
                routedomain: result[0].domain,
            });
            this.modalStateServicekey.isShow = false;

        },
        //随机生成授权验证码
        randomAuthCode() {
            // this.randomMD5 = this.G.randMD5();
            this.form.setFieldsValue({
                authcode: this.G.randMD5()
            })
        },
        //新增
        add(values) {
            this.$store
                .dispatch({
                    type: this.addType,
                    params: values
                })
                .then((response) => {
                    if (response.data.success == '1') {
                        this.$router.push({
                            path: "list"
                        });
                    }

                });
        },
        //复制
        copy(values) {
            this.$store
                .dispatch({
                    type: this.addType,
                    params: values
                })
                .then((response) => {
                    if (response.data.success == '1') {
                        this.$router.push({
                            path: "list"
                        });
                    }

                });
        },
        //修改
        edit(values) {
            values.id = this.record.id;
            this.$store
                .dispatch({
                    type: this.editType,
                    params: values
                })
                .then((response) => {
                    if (response.data.success == '1') {
                        this.$router.push({
                            path: "list",
                            query: JSON.parse(this.$route.query.referer)
                        });
                    }
                });
        },
        //表单提交
        handleSubmit(e) {
            e.preventDefault();
            let skbefore = this.servicekeyBefore;
            let cAction = this.action;

            this.form.validateFields((err, values) => {
                if (err) return;
                //根据路由的action, 动态绑定 新增 或 修改操作
                console.log(skbefore)
                values.servicekey = skbefore ? skbefore + values.servicekey : values.servicekey
                // this[cAction](values);
                //递归调用不同环境
                if(this.action == 'add'  && this.C.Env != 'pro'){
                    this.handleCover(0,values)
                }
                else{
                    this[cAction](values);
                }

            });
        },

        handleCover(c_index,record){
            //appenv
            //id
            let that = this;
            console.log(c_index)
            let params = {
                ...record,
                urlparams:false,
            }

            params.appenv = that.checkEnvs[c_index]

            that.tloading = true;

            that.$store.dispatch({
                type: "servicekey/coverP",
                params:params
            }).then(()=>{
                if(c_index < that.checkEnvs.length - 1){
                    that.handleCover(c_index + 1,record)
                }
                else{
                    that.message.success('新增成功')
                    that.$router.push({
                        path: "list"
                    });
                    that.tloading = false;
                }
            }).catch(() => {
                that.tloading = false;

            });

        },
        initSelecter() {
            let that = this
            let params = {
                urlparams:false
            };
            that.$store.dispatch({
                type: 'branch/getallbranches',
                params:params
            }).then((res)=>{
                if(res.status == 200){
                    that.data = res.data

                }
                else{
                    that.data = []
                }
            })
        },
    },
    mounted() {
        this.initSelecter();
        const {query, params} = this.$route;
        if (this.isGuide == "process") {
            params.action = "add";
            this.action = "add"
            this.c_title = '添加服务'
        }
        if (params.action != "add") {
            this.$store.dispatch({
                type: this.detailType,
                params: query
            }).then(res => {
                console.log(res)
                this.handleDomainChange(this.record.domain, this.record.servicekey)
            });
        } else {
            this.handleDomainChange('new', '')
        }
    }
};
</script>

<style scoped>
</style>
